import React from "react";

const ComingSoon = () => {
  return <div className="text-[3rem] relative ">Coming Soon</div>;
};

export default ComingSoon;
